import { atom } from "jotai";

import { currentModalStepAtom } from "../stores";

export const goToTransferOwnershipStepAtom = atom(null, (_, set) => {
  set(currentModalStepAtom, { type: "TransferOwnership" });
});
